import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Educational App">
                <h1>Top Education Software Development Services in USA</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Revolutionize the traditional education system by streamlining
                  the overall academic structure with next-gen education
                  software development services. In a digital era where students
                  are prone to digital interactions, it is a wise choice to take
                  a digital approach to education. So, you can leverage this
                  medium by collaborating with our reliable education software
                  development company. This can be your opportunity to unlock
                  the potential of your educational structure and increase
                  student interactions by 60%.
                </p>
                <ul>
                  <li> management systems</li>
                  <li>raining/academics</li>
                  <li>live modules/assessment</li>
                  <li> and adaptable</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
